import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";

import SidebarComponent from "../components/home/sidebarComponent";
import ReportComponent from "../components/reports/reportsComponent";
import { SessionUserStyles } from "./PagesStyle";
import { LoadingComponent, SnackbarCommonComponent } from "../components/common";
import { mapMessageCodeToIcon } from "../helpers/extensions";
import { cleanMessage } from "../actions/ReportActions";

class ReportsPage extends Component {
	render() {
		const {
			classes, isLoading, message, messageCode, cleanMessageInternal, mixpanel
		} = this.props;

		return (
			<div className={classes.root}>
				<CssBaseline />
				<SidebarComponent />
				<main className={classes.content}>
					<LoadingComponent isLoading={isLoading} />
					<SnackbarCommonComponent key="SnackBarUpdateReports" variant={mapMessageCodeToIcon(messageCode)} open={(!!message)} body={message} onCloseModal={cleanMessageInternal} />
					<div className={classes.appBarSpacer} />
					<ReportComponent mixpanel={mixpanel} />
				</main>
			</div>
		);
	}
}

ReportsPage.propTypes = {
	classes: PropTypes.object.isRequired,
	messageCode: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	message: PropTypes.string
};

const mapStateToProps = state => ({
	isLoading: state.employees.isLoading || state.reports.isLoading || state.reportsPayment.isLoading,
	messageCode: state.reports.messageCode || state.reportsPayment.messageCode,
	message: state.reports.message || state.reportsPayment.message
});

const mapDispatchToProps = dispatch => ({
	cleanMessageInternal: bindActionCreators(cleanMessage, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SessionUserStyles)(ReportsPage));
